import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { Screen, SCREEN_CONTROL, ControlStateSource, dropdownsource } from 'src/app/models/common';
import { ConfigureTemplateModalComponent } from './configure-template-modal/configure-template-modal.component';
import { UmSummaryService } from '../../services/um/um-summary.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';

@Component({
  selector: 'ist-document-template-definition',
  templateUrl: './ist-document-template-definition.component.html',
  styleUrls: ['./ist-document-template-definition.component.scss']
})
export class IstDocumentTemplateDefinitionComponent implements OnInit {
  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  tempoperations;
  rowData;
  screencontrols: Screen;
  advanceSearch;
  selectedRow;
  tempdropsource: dropdownsource;
  sourceitems: dropdownsource[] = [];
  moduleList = [];
  userForm: UntypedFormGroup;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private adminsummaryService: AdministrationSummaryService,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
    private commonservice: CommonService
  ) {

  }

  ngOnInit() {
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      MODULE_ID: new UntypedFormControl("")
    });
    this.getModulesList();
    this.columnDefs = [
      {
        "headerName": "Programs",
        "field": "NAME"
      },
      {
        "headerName": "SUB_MODULE",
        "field": "SUB_MODULE",
        "hide":"true"
      }
    ];
    this.tempoperations = [];
    if(this.commonservice.getScreenPermission("624","E")){
      this.tempoperations.push({
        "name": "Edit",
          "id": "Edit"
      });
    }
    this.advanceSearch=
    {
      "fields": [
        {
          "label": "Code",
          "field": "CODE",
          "type": "text"
        },
        {
          "label": "Name",
          "field": "NAME",
          "type": "text"
        },
        {
          "label": "Module",
          "field": "MODULE_ID",
          "type": "dropdown",
          "options": this.moduleList,
        }
      ]

    }

    this.operations = this.tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.getScreenslist();
  }

  getModulesList(): void {
    this.adminsummaryService.getModuleByOrgId('api/common/getmoduleslist').subscribe((result) => {
      this.moduleList = result;
    });
  }
  getScreenslist() {
    this.summaryService.getDocTemp("-1").subscribe(summary => {
      this.rowData = summary;
    });
    //this.summaryService.getScreenRepositorySummary("0").subscribe(summary => {
    //  this.rowData = summary;
    //});
  }
  SearchClear() {
    this.userForm.reset();
    //this.getScreenslist();
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    let modalRef = this.modalService.open(ConfigureTemplateModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'New',
      content: { id: event.data['ID'], MODULE_ID: event.data['MODULE_ID'],
      SUB_MODULE: event.data['SUB_MODULE'] }
    }
  }

  Edit(RcordData:any) {
    this["self"].modalRef = this['self'].modalService.open(ConfigureTemplateModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    this["self"].modalRef.componentInstance.Content = {
      heading: 'New',
      content: { id: RcordData['ID'], MODULE_ID: RcordData['MODULE_ID'],
      SUB_MODULE: RcordData['SUB_MODULE'] }
    }
  }
  AdvanceSearch() {
    var formData = this.userForm.value;
 ;
    this.adminsummaryService.getTemplateSummary(formData).subscribe(summary => {
      this.rowData = summary;
    });

  }
}
